export const typography = {
	fontFamily: ["Gotham", "Graphik", "Helvetica", "Arial", "sans-serif"].join(","),
	h1: { fontWeight: 700 },
	h2: { fontWeight: 700 },
	h3: { fontWeight: 700 },
	h4: { fontWeight: 700 },
	h5: { fontWeight: 700 },
};
